import { DynamicStandaloneTwitter } from '@/components/Twitter';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorTwitter: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneTwitter
      markup={data.oembed.html}
      data-content-index={meta.contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorTwitter;
